import React, { useState, useEffect } from "react";
import $ from "jquery";
import { useLocation } from "react-router";
import { useNavigate } from "react-router-dom";
import back from "../assets/images/back.png";
import axios from "axios";
import { message } from "antd";

export default (props) => {
  const [fhistoryDisease1, setFHistoryDisease1] = useState("");
  const [fhistoryRelation1, setFHistoryRelation1] = useState("");
  const [fhistoryDisease2, setFHistoryDisease2] = useState("");
  const [fhistoryRelation2, setFHistoryRelation2] = useState("");
  const [buttonHide, setButtonHide] = useState(false);
  const [msg, setMsg] = useState("");
  const [seesionId, setSessionId] = useState(Number);
  const [relation, setRelation] = useState([]);
  const [familyHistoryDisease, setFamilyHistoryDisease] = useState([]);

  const location = useLocation();
  console.log(location.state);

  const navigate = useNavigate();

  useEffect(() => {
    const getFamilyDeatilsDetails = async () => {
      let isMessageShown = false;
      const token = localStorage.getItem("token");
      const headers = {
        Authorization: `Bearer ${token}`, // Add the token to the request headers
      };

      let id = localStorage.getItem("patientid");
      console.log(id);
      setSessionId(id);

      if (location.state.family_history_1_disease != "") {
        setFHistoryDisease1(location.state.family_history_1_disease);
        setFHistoryDisease2(location.state.family_history_2_disease);
        setFHistoryRelation1(location.state.family_history_1_relation);
        setFHistoryRelation2(location.state.family_history_2_relation);
      }

      try {
        const response = await axios.get(
          `${process.env.REACT_APP_GLOBAL_BASEURL}/api/commonapi/PickList/get_family_ralation?MDT=PM&user_role=rp`,
          { headers }
        );

        console.log(response.data);
        if (response.data.status == "1") {
          setRelation(response.data.response);
        }

        // axios.get(`${process.env.REACT_APP_GLOBAL_BASEURL}/api/commonapi/PickList/get_family_ralation`).then((response) => {
        //     console.log(response.data);
        //     if (response.data.status == '1') {
        //         setRelation(response.data.response);
        //     }
        // });
      } catch (error) {
        if (!isMessageShown) {
          // Display error message based on the response or fallback to a default message
          if (error.response && error.response.status == '401') {
            console.error("Unauthorized access. Logging out.");
            message.error(error.response.data?.message || "Unauthorized");
            logoutHandler(); // Ensure logout happens here for unauthorized access
          } else {
            // console.error("Error:", error.message);
            message.error("An error occurred. Please try again.");
          }
          isMessageShown = true; // Prevent further messages
        }
      }

      try {
        const response = await axios.get(
          `${process.env.REACT_APP_GLOBAL_BASEURL}/api/commonapi/PickList/get_family_disease?MDT=PM&user_role=rp`,
          { headers }
        );
        console.log(response.data);
        if (response.data.status == "1") {
          setFamilyHistoryDisease(response.data.response);
        }
        // axios.get(`${process.env.REACT_APP_GLOBAL_BASEURL}/api/commonapi/PickList/get_family_disease`).then((response) => {
        //     console.log(response.data);
        //     if (response.data.status == '1') {
        //         setFamilyHistoryDisease(response.data.response);
        //     }
        // });
      } catch (error) {
        if (!isMessageShown) {
          // Display error message based on the response or fallback to a default message
          if (error.response && error.response.status == '401') {
            console.error("Unauthorized access. Logging out.");
            message.error(error.response.data?.message || "Unauthorized");
            logoutHandler(); // Ensure logout happens here for unauthorized access
          } else {
            // console.error("Error:", error.message);
            message.error("An error occurred. Please try again.");
          }
          isMessageShown = true; // Prevent further messages
        }
      }
    };
    getFamilyDeatilsDetails();
  }, []);

  const logoutHandler = () => {
    localStorage.removeItem("phoneNo");
    localStorage.removeItem("patientid");
    localStorage.removeItem("patientLocalImage");
    localStorage.removeItem("patientLocalData");
    localStorage.removeItem("patientUniqueId");
    localStorage.removeItem("chronic_illness_data");
    localStorage.removeItem("allergic_information_data");
    localStorage.removeItem("family_relation_data");
    localStorage.removeItem("family_disease_data");
    localStorage.removeItem("token");

    navigate("/Login");
  };

  const disease1ChangeHandler = (e) => {
    setFHistoryDisease1(e.target.value);
    console.log(e.target.value);
  };
  const disease2ChangeHandler = (e) => {
    setFHistoryDisease2(e.target.value);
  };
  const relation1ChangeHandler = (e) => {
    setFHistoryRelation1(e.target.value);
  };
  const relation2ChangeHandler = (e) => {
    setFHistoryRelation2(e.target.value);
  };

  const saveHandler = (e) => {
    const token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${token}`,
    };

    setButtonHide(true);
    e.preventDefault();
    let formdata = $(e.target);
    formdata = new FormData();

    formdata.append("patient_id", seesionId);
    formdata.append("family_history_1_disease", fhistoryDisease1);
    formdata.append("family_history_1_relation", fhistoryRelation1);
    formdata.append("family_history_2_disease", fhistoryDisease2);
    formdata.append("family_history_2_relation", fhistoryRelation2);
    formdata.append("MDT","PM");
    formdata.append("user_role","rp");

    $.ajax({
      type: "POST",
      url: `${process.env.REACT_APP_GLOBAL_BASEURL}/api/patientapi/PatientHealthProfile/update_family_history_by_patientid`,
      data: formdata,
      processData: false,
      contentType: false,
      headers: headers,
      success(data) {
        console.log(data);
        navigate("/PatientHealthProfile");
      },
      error: function (err) {
        if (err.status === 401) {
          // Token expired, show message and log out
          message.error(err.responseJSON.message);
          logoutHandler();
        } else {
          console.error("Error occurred:", err.responseText);
                      alert(`Error has occurred: ${err.responseText}`);
        }
        setButtonHide(false);
      },
    });
  };

  return (
    <div className="background-container">
      <header className="header">
        <button
          className="back-button"
          onClick={() => navigate("/PatientHealthProfile")}
        >
          &#8592;
        </button>
        <h1 className="header-title">Edit Family History</h1>
      </header>

      <div className="first-div">
        <div style={{ display: "flex", flexDirection: "row", height: "auto" }}>
          <table
            id="prescriptiondata"
            style={{
              width: "auto",
              paddingRight: 5,
              borderRadius: 5,
              marginLeft: "7%",
              marginRight: "5%",
            }}
          >
            <thead>
              <tr>
                <th
                  style={{
                    width: "50%",
                    textAlign: "center",
                    fontWeight: "normal",
                    fontSize: 13,
                  }}
                >
                  Disease
                </th>
                <th
                  style={{
                    width: "40%",
                    textAlign: "center",
                    fontWeight: "normal",
                    fontSize: 13,
                    marginRight: 10,
                  }}
                >
                  Relation
                </th>
              </tr>
            </thead>
            <tbody>
              <td style={{ textAlign: "left" }} className="value">
                <div className="select-wrapper">
                  <select
                    name="fhistoryDisease1"
                    value={fhistoryDisease1}
                    onChange={(event) => disease1ChangeHandler(event)}
                    className="input-bordered"
                    style={{ fontSize: 13, fontWeight: "bold", width: "100%" }}
                  >
                    <option value="">Select</option>
                    {familyHistoryDisease.map((val) => {
                      return <option value={val.code}>{val.value}</option>;
                    })}
                  </select>
                </div>
              </td>
              <td style={{ textAlign: "left" }} className="value">
                <div className="select-wrapper">
                  <select
                    name="fhistoryRelation1"
                    value={fhistoryRelation1}
                    onChange={(event) => relation1ChangeHandler(event)}
                    className="input-bordered"
                    style={{ fontSize: 13, fontWeight: "bold", width: "100%" }}
                  >
                    <option value="">Select</option>
                    {relation.map((val) => {
                      return <option value={val.code}>{val.value}</option>;
                    })}
                  </select>
                </div>
              </td>
            </tbody>
            <tbody>
              <td style={{ textAlign: "left" }} className="value">
                <div className="select-wrapper">
                  <select
                    name="fhistoryDisease2"
                    value={fhistoryDisease2}
                    onChange={(event) => disease2ChangeHandler(event)}
                    className="input-bordered"
                    style={{ fontSize: 13, fontWeight: "bold", width: "100%" }}
                  >
                    <option value="">Select</option>
                    {familyHistoryDisease.map((val) => {
                      return <option value={val.code}>{val.value}</option>;
                    })}
                  </select>
                </div>
              </td>
              <td style={{ textAlign: "left" }} className="value">
                <div className="select-wrapper">
                  <select
                    name="fhistoryRelation2"
                    value={fhistoryRelation2}
                    onChange={(event) => relation2ChangeHandler(event)}
                    className="input-bordered"
                    style={{ fontSize: 13, fontWeight: "bold", width: "100%" }}
                  >
                    <option value="">Select</option>
                    {relation.map((val) => {
                      return <option value={val.code}>{val.value}</option>;
                    })}
                  </select>
                </div>
              </td>
            </tbody>
          </table>

          {/* <div style={{ width: '50%' }}>
                        <p className="label" style={{ marginTop: 10 }}>Disease:&nbsp;</p>
                    </div> */}

          {/* <div className="select-wrapper">
                        <select
                            name="fhistoryDisease1"
                            value={fhistoryDisease1}
                            onChange={(event) => disease1ChangeHandler(event)}
                            className="input-bordered"
                            style={{ fontSize: 13, fontWeight: 'bold', width: 100 }}

                        >
                            {
                                familyHistoryDisease.map((val) => {
                                    return (

                                        <option >{val.disease}</option>

                                    )
                                })

                            }
                        </select>
                    </div> */}

          {/* <div style={{ display: 'flex', flexDirection: 'row', marginLeft: 20 }}>
                        <div style={{ width: '50%' }}>
                            <p className="label" style={{ marginTop: 10 }} >Relation:&nbsp;</p>
                        </div>
                        <div className="select-wrapper">
                            <select
                                name="fhistoryRelation1"
                                value={fhistoryRelation1}
                                onChange={(event) => relation1ChangeHandler(event)}
                                className="input-bordered"
                                style={{ fontSize: 13, fontWeight: 'bold', width: 100 }}

                            >
                                {
                                    relation.map((val) => {
                                        return (
                                            <option >{val.value}</option>
                                        )
                                    })
                                }
                            </select>
                        </div>
                    </div> */}
        </div>

        {/* <div style={{ display: 'flex', flexDirection: 'row', marginTop: 15 }}>
                    <div style={{ width: '50%' }}>
                        <p className="label" style={{ marginTop: 10 }}>Disease:&nbsp;</p>
                    </div>



                    <div style={{ display: 'flex', flexDirection: 'row', marginLeft: 20 }}>
                        <div style={{ width: '50%' }}>
                            <p className="label" style={{ marginTop: 10 }} >Relation:&nbsp;</p>
                        </div>


                    </div>
                </div> */}
        <div
          style={{
            marginTop: 20,
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
          }}
        >
          <form method="post" onSubmit={(event) => saveHandler(event)}>
            {buttonHide == false ? (
              <button type="submit" className="btn btn-auto btn-success">
                Update
              </button>
            ) : (
              <p style={{ fontSize: 14, fontWeight: "bold", color: "green" }}>
                Updating...
              </p>
            )}
          </form>
        </div>
        <div style={{ marginLeft: "auto", marginRight: "auto" }}>
          {msg != "" ? (
            <p
              style={{
                marginTop: 20,
                fontSize: 13,
                fontWeight: "bold",
                color: "green",
                marginLeft: "auto",
                marginRight: "auto",
              }}
            >
              {msg}
            </p>
          ) : null}
        </div>
      </div>
    </div>
  );
};
